import { Fragment } from 'react';
import { cx } from './util';

// §2.6 Calendar cell (Calendar, Scheduler, Who's out, Talent availability).
// items: [{ id, label }] — shows up to max, then "+N more". onClick makes the cell a button.
// For interactive items (drag, open, remove) leave onClick off and pass renderItem(item) for each item and an
// optional action (a control beside the day number); any other prop (drag handlers, data-drop) goes on the cell.
export default function CalendarCell({ date, outside = false, today = false, selected = false, items = [], max = 3, onClick, renderItem, action, ...rest }) {
  const d = new Date(`${date}T12:00:00Z`);
  const Tag = onClick ? 'button' : 'div';
  const label = d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
  const day = <span className="ui-cal__day" aria-hidden="true">{d.getUTCDate()}</span>;
  return (
    <Tag type={onClick ? 'button' : undefined} className={cx('ui ui-cal', outside && 'ui-cal--outside', today && 'ui-cal--today')}
      aria-selected={onClick ? selected : undefined} aria-label={`${label}${items.length ? `, ${items.length} items` : ''}`} onClick={onClick}
      role={!onClick && renderItem ? 'group' : undefined} {...rest}>
      {action ? <span className="ui-cal__head">{day}{action}</span> : day}
      {items.slice(0, max).map(it => (renderItem
        ? <Fragment key={it.id}>{renderItem(it)}</Fragment>
        : <span key={it.id} className="ui-cal__item" title={it.label}>{it.label}</span>))}
      {items.length > max && <span className="ui-cal__more">+{items.length - max} more</span>}
    </Tag>
  );
}
